import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import useForm from 'react-hook-form';

import Breadcrumb from '../common/breadcrumb';
import { useStateValue } from '../../store';

const ClientInvitation = withRouter(() => {
    const [{ auth }] = useStateValue();
    const {
        handleSubmit: handleSubmitPush,
        register: registerPush,
        errors: errorsPush,
    } = useForm();

    const sendInvitation = (data) => {
        const phoneParsed = data.phone.replace('0', '58');
        const nameParsed = auth.user.name.split(' ')[0];
        const waUrl = `https://wa.me/${phoneParsed}?text=Hola%20Sr(a).%20${data.name}%2C%20un%20gusto.%0A%0AMi%20nombre%20es%20${nameParsed}%20de%20Aguaman.%0A%0ATal%20como%20le%20indiqu%C3%A9%20con%20nuestro%20servicio%20express%20recibe%20su%20botell%C3%B3n%20de%20agua%20en%2030%20minutos%2C%20le%20llevamos%20un%20botell%C3%B3n%20lleno%20y%20nos%20da%20su%20envase%20vac%C3%ADo.%0A%0APrecio%20del%20servicio%3A%20*12.000%20pesos*%20(agua%20y%20delivery)%0A%0APara%20pedidos%20presione%20el%20siguiente%20enlace.%0A%0Ahttps%3A%2F%2Faguamandelivery.com%2Fpedir-botellon`;

        window.open(waUrl);

        return;
    };

    return (
        <Fragment>
            <Breadcrumb title="Invitar cliente" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <form
                                    onSubmit={handleSubmitPush(sendInvitation)}
                                    className="needs-validation user-add"
                                    noValidate=""
                                >
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">
                                            <span>*</span> Primer Nombre
                                        </label>
                                        <input
                                            className="form-control col-xl-4 col-md-7"
                                            type="text"
                                            name="name"
                                            ref={registerPush({
                                                required: true,
                                            })}
                                        />
                                        <p className="message-error-input">
                                            {errorsPush.name &&
                                                errorsPush.name.type === 'required' &&
                                                'Nombre obligatorio'}
                                        </p>
                                    </div>
                                    <div className="form-group row mb-5">
                                        <label className="col-xl-3 col-md-4">
                                            <span>*</span> Teléfono
                                        </label>
                                        <input
                                            className="form-control col-xl-5 col-md-7"
                                            type="tel"
                                            name="phone"
                                            ref={registerPush({
                                                required: true,
                                            })}
                                        />
                                        <p className="message-error-input">
                                            {errorsPush.phone &&
                                                errorsPush.phone.type === 'required' &&
                                                'Teléfono obligatorio'}
                                        </p>
                                    </div>
                                    <div className="col-sm-12 text-center mt-5 mb-3">
                                        <button
                                            type="submit"
                                            className="btn btn-success"
                                            onClick={handleSubmitPush(sendInvitation)}
                                        >
                                            Enviar invitación
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
});

export default ClientInvitation;
